import Vue from 'vue';
import VS2 from 'vue-script2';
import Ads from 'vue-google-adsense';

Vue.use(VS2);

Vue.use(Ads.Adsense);
Vue.use(Ads.InArticleAdsense);
Vue.use(Ads.InFeedAdsense);
